import { Component, OnInit } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { IWeissmanModalComponent } from '../../../../Compliance/WeissmanModalService';
import { ModalWrapperComponent } from '../../../../UI-Lib/Modal-Wrapper/modalWrapper.component';
import { FormsModule } from '@angular/forms';
import { CurrencyMaskDirective } from '../../../../UI-Lib/Currency/Mask/currencyMask.directive';
import { ContractsInvoicesService } from '../../../../Common/Contracts-Invoices/contract-invoices.service';
import { ContractTermData } from '../../../../Common/Contracts-Invoices/contract-invoices.model';
import { ServiceInfo } from '../contractTermsCompany.component';

export interface ConfigureFeeEscalatorModalParams {
    companyId: number;
    allData: ContractTermData;
    services: ServiceInfo[];
}

@Component({
    selector: 'configure-fee-escalator',
    templateUrl: './configureFeeEscalator.component.html',
    imports: [FormsModule, ModalWrapperComponent, CurrencyMaskDirective],
})
export class ConfigureFeeEscalatorComponent
    implements OnInit, IWeissmanModalComponent<ConfigureFeeEscalatorModalParams, boolean>
{
    constructor(
        private readonly _modalRef: BsModalRef,
        private readonly _contractsInvoicesService: ContractsInvoicesService,
    ) {}

    params: ConfigureFeeEscalatorModalParams;
    result: boolean;

    services: ServiceInfo[];
    newFeeEscalator: number;
    newEscalatorServiceTypes: number[] = [];
    savingFeeEscalator: boolean;

    ngOnInit(): void {
        this.services = this.params.services;

        if (this.params.allData.feeEscalator) {
            this.newFeeEscalator = this.params.allData.feeEscalator * 100;
            this.newEscalatorServiceTypes = Array.prototype.slice.apply(this.params.allData.escalatorServiceTypes);
        } else {
            this.newFeeEscalator = 0;
            this.newEscalatorServiceTypes = Array.prototype.slice.apply(this.services.map((s) => s.id));
        }
    }

    cancel(): void {
        this._modalRef.hide();
    }

    async save(): Promise<void> {
        this.savingFeeEscalator = true;
        try {
            await this._contractsInvoicesService.saveFeeEscalator(this.params.companyId, {
                fixedFeeEscalator: this.newFeeEscalator / 100,
                contractServiceTypes: this.newEscalatorServiceTypes,
                companyRowVersion: this.params.allData.companyRowVersion,
            });
            this.result = true;
            this._modalRef.hide();
        } finally {
            this.savingFeeEscalator = false;
        }
    }

    serviceTypeSelected(serviceTypeId: number): boolean {
        return this.newEscalatorServiceTypes.some((t) => t == serviceTypeId);
    }

    checkedServiceType(serviceTypeId: number, checked: boolean): void {
        if (checked) {
            this.newEscalatorServiceTypes.push(serviceTypeId);
        } else {
            const index = this.newEscalatorServiceTypes.findIndex((t) => t == serviceTypeId);
            if (!(index >= 0)) {
                throw new Error(`Array unexpectedly missing value: ${serviceTypeId}`);
            }

            this.newEscalatorServiceTypes.splice(index, 1);
        }
    }
}
